import React, { useEffect, useState } from "react";
import LegalPage, { DomainDetails } from "./LegalPage";
import { fetchDomainDetails } from "./domainDetailsApi";
import { privacyPolicySections } from "./legalPagesData";

const PrivacyPolicy: React.FC = () => {
  const [domainDetails, setDomainDetails] = useState<DomainDetails>({});
  const entityName = domainDetails.companyName || "an entity";

  useEffect(() => {
    fetchDomainDetails()
      .then(setDomainDetails)
      .catch((error) => {
        console.error("Domain API Error:", error);
        setDomainDetails({});
      });
  }, []);

  return (
    <LegalPage
      title="Privacy Policy"
      description={
        <>
          We as <strong>{entityName}</strong> respect your privacy and are
          committed to protecting your personal information. This Privacy Policy
          explains how we collect, use, store, and share your information when
          you use our mobile application and website. By using our services, you
          agree to the practices described in this policy.
        </>
      }
      effectiveDate="19 February 2026"
      sections={privacyPolicySections}
      domainDetails={domainDetails}
    />
  );
};

export default PrivacyPolicy;
